<template>
  <div class="row">
    <div class="col-4 text-center">
      <div class="card-blue-scroll-small">
        <div class="card-primary">
          <p class="text-m text-bold">Piket Hari {{ hariPiket }}</p>
          <div
            class="row mt-10"
            v-for="jadwalPiket in piket"
            :key="jadwalPiket.user"
          >
            <div class="col-12">
              <div class="card-secondary">
                <div class="ultah">
                  <div class="p-ultah">
                    <p class="text-bold2 text-l">{{ jadwalPiket.user }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 text-center">
      <div class="card-blue-scroll-small">
        <div class="card-primary">
          <p class="text-m text-bold">Absen Hari ini</p>
          <div
            class="row mt-10"
            v-for="(absen, index) in dataAbsent"
            :key="`absen-${index}`"
          >
            <div class="col-12">
              <div class="card-secondary">
                <div class="ultah">
                  <!-- <img src="antarmuka-user/img/ultah.png" alt=""> -->
                  <div class="p-ultah">
                    <p class="text-bold2 text-l">{{ absen.fullname }}</p>
                    <p class="text-sm text-l text-bold">
                      {{ absen.absent_desc }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 text-center">
      <div class="card-blue-scroll-small">
        <div class="card-primary">
          <p class="text-m text-bold">Ultah Hari ini</p>
          <carousel
            :items="1"
            :nav="false"
            :dots="false"
            :autoplay="true"
            :loop="true"
            :autoplayTimeout="30000"
            v-if="dataBday.length > 1"
          >
            <div
              class="row"
              v-for="(ultah, index) in dataBday"
              :key="`ultah-${index}`"
            >
              <div class="col-12">
                <div class="">
                  <div class="ultah">
                    <div class="row">
                      <div class="col-12">
                        <img
                          src="@/assets/antarmuka-user/img/ultah.png"
                          alt=""
                          class="vertical-align"
                        />
                      </div>
                      <div class="col-12 mt-30 card-secondary">
                        <div class="p-ultah">
                          <p class="text-bold2 text-l">{{ ultah.fullname }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
          <div
            class="row"
            v-for="(ultah, index) in dataBday"
            :key="`ultah-${index}`"
            v-else
          >
            <div class="col-12">
              <div class="">
                <div class="ultah">
                  <div class="row">
                    <div class="col-12">
                      <img
                        src="@/assets/antarmuka-user/img/ultah.png"
                        alt=""
                        class="vertical-align"
                      />
                    </div>
                    <div class="col-12 mt-30 card-secondary">
                      <div class="p-ultah">
                        <p class="text-bold2">{{ ultah.fullname }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import carousel from "vue-owl-carousel";

export default {
  name: "BdayAndAbsent",
  components: {
    carousel,
  },
  data() {
    return {
      piket: [],
      hariPiket: [],
      dataAbsent: [],
      dataBday: [],
    };
  },
  methods: {
    drawPiket(data) {
      // console.log(data)
      this.hariPiket = data[0].hari_piket;
      this.piket = data;
    },
    drawAbsent(data) {
      // console.log(data)
      this.dataAbsent = data;
    },
    drawBday(data) {
      this.dataBday = data;
      // console.log(data)
    },
  },
  mounted() {
    var dateNow = moment().format("YYYY-MM-DD");
    var token = localStorage.token;
    // console.log(dateNow)

    axios
      .get(`admin/piket`)
      .then(
        (response) =>
          // handle success
          this.drawPiket(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );

    axios
      .get(`admin/absence?date=${dateNow}`)
      .then(
        (response) =>
          // handle success
          this.drawAbsent(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );

    axios
      .get(`admin/birthday`)
      .then(
        (response) =>
          // handle success
          this.drawBday(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );
  },
};
</script>

<style scoped>
.container-blue {
  height: 300px !important;
}

.card-secondary {
  border-radius: 7px;
  padding: 10px;
}

img {
  width: 45% !important;
}

.text-bold2 {
  font-weight: 700;
}

.card-blue-scroll-small {
  height: 410px;
}

.card-primary {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/BdayAndAbsent.vue